
const initModalCookie = () => {
  const dropdownButton = document.querySelector('.select-dropdown');
  const languageButton = document.querySelector('.language-selection');
  const navButtons = document.querySelectorAll('.uk-dropdown-nav .nav-link');
  const modal = document.querySelector('#language-modal'); // update if needed

  const hasSeenModal = sessionStorage.getItem('language_modal_shown') === 'true';

  if (modal) {
    if (hasSeenModal) {
      modal.remove();
    } else if (window.UIkit) {
      UIkit.modal(modal).show();
    }
  }

  if (!dropdownButton || !languageButton) return;

  const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  };

  const getSelectionFromUrl = (href) => {
    const url = new URL(href, window.location.origin);
    return url.searchParams.get('selection') || '';
  };

  navButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      const newHref = button.getAttribute('data-href');
      const span = button.querySelector('.wpml-ls-native');
      const newText = span ? span.textContent.trim() : button.textContent.trim();

      if (!newHref) return;

      dropdownButton.setAttribute('data-href', newHref);
      dropdownButton.textContent = newText;

      const dropdown = button.closest('[uk-dropdown]');
      dropdown.classList.remove('uk-open');
    });
  });

  languageButton.addEventListener('click', () => {
    const href = dropdownButton.getAttribute('data-href');
    if (!href) return;

    const selection = getSelectionFromUrl(href);

    sessionStorage.setItem('language_modal_shown', 'true');

    if (selection) {
      setCookie('mc_selected_language_v2', selection);
    }

    window.location.href = href;
  });
};

export default initModalCookie;
